import { useLocation, useParams } from "react-router-dom";
import BottomAppBar from "../../../components/BottomBar";
import Navigation from "../../../components/Navigation";
import { useCallback, useEffect, useState } from "react";
import { StarsSubCategoriesLang } from "../../../http/server-apis";
import CategoryDetail from "../../../components/home/category/CategoryDetail";
import Loader from "../../../components/loaders/Loader";
import CategoryContent from "../../../components/home/category/CategoryContent";
import { useSelector } from "react-redux";

const Category = () => {
  const { selectedLanguage } = useSelector((state) => state.Language);
  const { state } = useLocation();
  const { category_id } = useParams();
  const [categoryData, setCategoryData] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const getCategory = useCallback(async () => {
    setIsLoading(true);
    const { data } = await StarsSubCategoriesLang("post", {
      data: {
        CategoryID: Number(category_id),
        LangCode: selectedLanguage,
      },
    });
    if (data.Status === "success") {
      setCategoryData(data);
    }

    setIsLoading(false);
  }, [category_id, selectedLanguage]);

  useEffect(() => {
    getCategory();
  }, [category_id, getCategory]);

  return (
    <>
      <Navigation
        title={state?.CategoryName || "Subcategory"}
        appBarColor={state?.Color || "orange"}
      />
      <div className="fixed-layout-main flex">
        {isLoading ? (
          <div className="white-card my-2 ">
            <Loader />
          </div>
        ) : (
          <div className="white-card my-2 ">
           
              {categoryData?.HasChild === 0 ? (
                <CategoryDetail
                  HasChild={categoryData?.HasChild}
                  categoryData={categoryData?.Categories[0]}
                  color={state?.Color}
                />
              ) : categoryData?.HasChild === 1 ? (
                <CategoryDetail
                  HasChild={categoryData?.HasChild}
                  categoryData={categoryData?.Subcategories[0]}
                  color={state?.Color}
                />
              ) : (
                <CategoryContent
                  HasChild={categoryData?.HasChild}
                  categoryData={categoryData?.Subcategories}
                  Title={state?.CategoryName}
                  AppBarColor={state?.Color}
                />
              )}
            </div>
          
        )}
      </div>

      <BottomAppBar />
    </>
  );
};

export default Category;
